import clsx from 'clsx';
import { AnimatePresence, motion } from 'motion/react';

import { useTags } from '@/hooks/rxdb-models';
import { useHiddenElementsCount } from '@flintmint/web-shared/hooks/use-hidden-elements-count';

import { OverflowingTags } from '@/components/overflowing-tags';
import { Tooltip } from '@flintmint/web-shared/components/tooltip';
import { ColorIndicator } from '@flintmint/web-shared/components/color-indicator';

import { animateOpacity } from '@flintmint/web-shared/constants/ui';

import styles from './inline-tags.module.scss';

export const InlineTags = (props: InlineTagsProps) => {
  const { tagIds } = props;

  const { data: tags } = useTags({ ids: tagIds });

  const { ref, visibleCount, hiddenCount } = useHiddenElementsCount(tags);

  const ready = visibleCount !== null && visibleCount !== 0;

  return (
    <AnimatePresence>
      {!!tags.length && (
        <motion.div {...animateOpacity} className={styles.inlineTagsHolder}>
          <div
            ref={ref}
            className={clsx(styles.inlineTags, {
              [styles.ready]: ready,
            })}
          >
            {tags?.map((tag, index) => (
              <Tooltip content={tag.name} key={tag.id}>
                <ColorIndicator
                  size="tiny"
                  color={tag.color}
                  className={clsx({
                    [styles.hidden]: !ready || !(visibleCount !== null && index < visibleCount),
                  })}
                />
              </Tooltip>
            ))}
          </div>
          {!!hiddenCount && <OverflowingTags tags={tags.slice(visibleCount ?? 0)} overflowCount={hiddenCount} />}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export interface InlineTagsProps {
  tagIds: string[];
}
